import styles from './ProctorIndicator.module.scss'

const ProctorIndicator = ({ active }) => {
  if (!active) return null
  return (
    <div className={styles.indicator}>
      <span className={styles.dot} />
      <span className={styles.label}>REC</span>
    </div>
  )
}

export default ProctorIndicator
